import React from "react";
import { Page, Text, View, Image, Font } from "@react-pdf/renderer";
import Header from "./Header";
import Footer from "./Footer";
import styles from "./PagesStyle/Page1Styles";
import MyCustomFont from "./fonts/Roboto-Italic.ttf";

Font.register({
  family: "italicFamily",
  src: MyCustomFont,
});

const formatNoDecimals = (cost) => {
  if (cost === null || cost === undefined || isNaN(cost)) {
    return "N/A";
  }
  return `${Number(cost).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
};

const formatMoney = (cost) => {
  if (cost === null || cost === undefined || isNaN(cost)) {
    return "N/A";
  }
  return `$${Number(cost).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const formatMoneyNoDecimals = (cost) => {
  if (cost === null || cost === undefined || isNaN(cost)) {
    return "N/A";
  }
  return `$${Number(cost).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
};

const formatNumber = (number) => {
  if (number === null || number === undefined || isNaN(number)) {
    return "N/A";
  }
  return Number(number).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const formatDate = (dateString) => {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "N/A"; // Return 'N/A' if the date is invalid
  }

  // Add one day to the date
  date.setDate(date.getDate() + 0);

  const options = { month: "long", day: "numeric", year: "numeric" };
  return date.toLocaleDateString("en-US", options); // Formats as "Month Day, Year"
};



const Page2 = ({ formData, companyLogo }) => (
  
  <Page size="LETTER" style={styles.pagePage2}>
    <Header formData={formData} companyLogo={companyLogo} />

    <View style={styles.parentContainerPage2}>
      {/* Left Column */}
      <View style={styles.leftContainerPage2}>
        <View style={styles.leftColumnPage2}>
          <Text style={[styles.sectionHeaderPage2, { top: 4 }]}>
            CLAIM INFORMATION
          </Text>
          <View style={styles.TitleBottomBorderPage2} />

          <View style={styles.rowContainerPage2}>
            <Text style={[styles.labelPage2, { top: 6 }]}>Vehicle Owner:</Text>
            <View style={styles.valueContainerPage2}>
              <Text style={styles.valuePage2}>
                {formData.vehicleOwner || "N/A"}
              </Text>
            </View>
          </View>

          <View style={styles.rowContainerPage2}>
            <Text style={[styles.labelPage2, { top: 6 }]}>File Number:</Text>
            <View style={styles.valueContainerPage2}>
              <Text style={styles.valuePage2}>
                {formData.fileNumber || "N/A"}
              </Text>
            </View>
          </View>

          <View style={styles.rowContainerPage2}>
            <Text style={[styles.labelPage2, { top: 6 }]}>Insurance Co:</Text>
            <View style={styles.valueContainerPage2}>
              <Text style={styles.valuePage2}>
                {formData.insuranceCo || "N/A"}
              </Text>
            </View>
          </View>

          <View style={styles.rowContainerPage2}>
            <Text style={[styles.labelPage2, { top: 6 }]}>Date of Loss:</Text>
            <View style={styles.valueContainerPage2}>
              <Text style={styles.valuePage2}>
                {formatDate(formData.dateOfLoss) || "N/A"}
              </Text>
            </View>
          </View>

          <View style={styles.rowContainerPage2}>
            <Text style={[styles.labelPage2, { top: 6 }]}>
              Claim Number & Type:
            </Text>
            <View style={styles.valueContainerPage2}>
              <Text style={styles.valuePage2}>
                {formData.claimNumber || "N/A"}
              </Text>
            </View>
          </View>

          <View style={{ bottom: 5 }}>
            <View style={styles.rowContainerPage2}>
              <Text style={styles.labelPage2}></Text>
              <View style={[styles.valueContainerPage2, { top: 3 }]}>
                <Text style={styles.valuePage2}>{formData.claimType}</Text>
              </View>
            </View>
          </View>

          {/* VEHICLE INFORMATION */}
          <Text style={[styles.sectionHeaderPage2]}>VEHICLE INFORMATION BALLS</Text>

          <View style={[{ top: 5 }]}>
            <View style={styles.sectionPage2}>
              <View style={styles.rowContainerPage2}>
                <Text style={styles.labelPage2}>VIN:</Text>
                <View style={styles.valueContainerPage2}>
                  <Text style={styles.valuePage2}>{formData.vin || "N/A"}</Text>
                </View>
              </View>

              <View style={styles.rowContainerPage2}>
                <Text style={styles.labelPage2}>Year, Make & Model:</Text>
                <View style={styles.valueContainerYMMPage2}>
                  <Text style={styles.valuePage2}>
                    {formData.yearMakeModel || "N/A"}
                  </Text>
                </View>
              </View>

              <View style={styles.rowContainerPage2}>
                <Text style={[styles.labelPage2, { top: 3 }]}>
                  Odometer Reading:
                </Text>
                <View style={styles.valueContainerPage2}>
                  <Text style={styles.valuePage2}>
                    {formatNoDecimals(formData.odometerReading)}
                  </Text>
                </View>
              </View>
            </View>
          </View>

          {/* DAMAGE / REPAIR AREA */}
          <Text style={[styles.sectionHeaderPage2, { top: 18 }]}>
            DAMAGE / REPAIR AREA
          </Text>

          <View style={styles.vehiclePage2}>
            <Text style={[styles.bodyDamagePage2, { left: 30, bottom: 148 }]}>
              Body Damage
            </Text>
            <View style={{ bottom: 9 }}>
              <Image
                style={[styles.rectangleIconPage2, { bottom: 7 }]}
                src="/Rectangle (2).png"
                alt="Vehicle Image"
              />
            </View>
            <View
              style={[styles.rectangleParentPage2, { left: 22, bottom: 30 }]}
            >
              {/* Checkbox placeholders */}
              {/* top */}
              <View style={{ bottom: 8 }}>
                <View style={[styles.checkboxPage2, { top: 2, left: 41 }]}>
                  {formData.checkbox1 ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>

                {/* half */}
                <View style={[styles.checkboxPage2, { top: 36, left: 23 }]}>
                  {formData.checkbox2 ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>

                {/* bottom */}
                <View style={[styles.checkboxPage2, { top: 70, left: 41 }]}>
                  {formData.checkbox3 ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>

                {/* half */}
                <View style={[styles.checkboxPage2, { top: 36, left: 57 }]}>
                  {formData.checkbox4 ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>

                {/* top */}
                <View style={[styles.checkboxPage2, { top: 2, left: 98 }]}>
                  {formData.checkbox5 ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>

                {/* half */}
                <View style={[styles.checkboxPage2, { top: 36, left: 127 }]}>
                  {formData.checkbox6 ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>

                {/* bottom */}
                <View style={[styles.checkboxPage2, { top: 66, left: 98 }]}>
                  {formData.checkbox7 ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>

                {/* top */}
                <View style={[styles.checkboxPage2, { top: 5, left: 155 }]}>
                  {formData.checkbox8 ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>

                {/* bottom */}
                <View style={[styles.checkboxPage2, { top: 66, left: 155 }]}>
                  {formData.checkbox9 ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>

                {/* top */}
                <View style={[styles.checkboxPage2, { top: 5, left: 195 }]}>
                  {formData.checkbox10 ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>

                {/* half */}
                <View style={[styles.checkboxPage2, { top: 36, left: 200 }]}>
                  {formData.checkbox11 ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>

                {/* bottom */}
                <View style={[styles.checkboxPage2, { top: 67, left: 195 }]}>
                  {formData.checkbox12 ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>

                {/* half */}
                <View style={[styles.checkboxPage2, { top: 36, left: 220 }]}>
                  {formData.checkbox13 ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>

                {/* Damage labels */}
                <Text style={styles.rightFrontPage2}>Right Front</Text>
                <Text style={styles.leftFrontPage2}>Left Front</Text>
                <Text style={styles.leftRearPage2}>Left Rear</Text>
                <Text style={styles.rightRearPage2}>Right Rear</Text>

                {/* OTHER SESSION OF CHECK FUCKING BOXES AAAAAAAAAAAAAAAHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHHH*/}
              </View>
              <View style={{}}>
                <View style={[styles.checkboxPage2, { top: 85, left: 1 }]}>
                  {formData.checkboxUnder ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>
                <Text
                  style={{
                    top: 85,
                    right: 100,
                    fontSize: 6,
                    color: "#808080",
                    fontFamily: "italicFamily",
                  }}
                >
                  Undercarrige
                </Text>

                <View style={[styles.checkboxPage2, { top: 100, left: 1 }]}>
                  {formData.checkboxPdr ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>
                <Text
                  style={{
                    top: 93,
                    right: 111,
                    fontSize: 6,
                    color: "#808080",
                    fontFamily: "italicFamily",
                  }}
                >
                  PDR
                </Text>

                <View style={[styles.checkboxPage2, { top: 85, right: 85 }]}>
                  {formData.checkboxWater ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>
                <Text
                  style={{
                    top: 71,
                    left: 82,
                    fontSize: 6,
                    color: "#808080",
                    fontFamily: "italicFamily",
                  }}
                >
                  Water Damage
                </Text>

                <View style={[styles.checkboxPage2, { top: 85, left: 85 }]}>
                  {formData.checkboxFire ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>
                <Text
                  style={{
                    top: 64,
                    right: 16,
                    fontSize: 6,
                    color: "#808080",
                    fontFamily: "italicFamily",
                  }}
                >
                  Fire Damage
                </Text>

                <View style={[styles.checkboxPage2, { top: 100, left: 85 }]}>
                  {formData.checkboxOther ? (
                    // Display the filled checkbox (e.g., a checkmark or another symbol) if selected
                    <Text style={[styles.checkmarkPage2, { fontSize: 14 }]}>
                      ✔
                    </Text>
                  ) : (
                    // Don't display anything when not selected (or show an empty box as needed)
                    <View style={styles.uncheckedBoxPage2} />
                  )}
                </View>
                <Text
                  style={{
                    top: 72,
                    right: 14,
                    fontSize: 6,
                    color: "#808080",
                    fontFamily: "italicFamily",
                  }}
                >
                  Other Damage
                </Text>
              </View>

              {/* END OF THE SHITTY CHECKBOXES */}
            </View>
          </View>

          {/* REPAIR ESTIMATE REVIEW */}

          <View style={{ top: 15 }}>
            <Text style={[styles.sectionHeaderPage2, { top: 10 }]}>
              REPAIR ESTIMATE REVIEW
            </Text>
          </View>

          <View style={{ top: 35 }}>
            <View style={styles.rowContainerPage2}>
              <Text style={styles.label2Page2}>Labor Hours:</Text>
              <View
                style={[
                  styles.valueContainerPage2,
                  { top: "0px", left: "175", position: "absolute" },
                ]}
              >
                <Text style={styles.valuePage2}>
                  {formData.laborHours || "N/A"}
                </Text>
              </View>
            </View>

            <View style={styles.rowContainerPage2}>
              <Text style={styles.label2Page2}>Structural Damage:</Text>
              <View
                style={[
                  styles.valueContainerPage2,
                  { top: "0px", left: "175", position: "absolute" },
                ]}
              >
                <Text style={styles.valuePage2}>
                  {formData.structuralDamage || "None Reported"}
                </Text>
              </View>
            </View>

            <View style={styles.rowContainerPage2}>
              <Text style={styles.label2Page2}>Airbag Deployment:</Text>
              <View
                style={[
                  styles.valueContainerPage2,
                  { top: "0px", left: "175", position: "absolute" },
                ]}
              >
                <Text style={[styles.valuePage2]}>
                  {formData.airbagDeployment === "yes"
                    ? "Airbag Deployment Reported"
                    : formData.airbagDeployment === "no"
                    ? "None Reported"
                    : ""}
                </Text>
              </View>
            </View>

            <View style={styles.rowContainerPage2}>
              <Text style={styles.label2Page2}>Prior Loss or UPD:</Text>
              <View
                style={[
                  styles.valueContainerPage2,
                  { top: "0px", left: "175", position: "absolute" },
                ]}
              >
                <Text style={styles.valuePage2}>
                  {formData.priorLoss === "yes"
                    ? "Prior Loss Reported"
                    : formData.priorLoss === "no"
                    ? "None Reported"
                    : ""}
                </Text>
              </View>
            </View>

            <View style={styles.rowContainerPage2}>
              <Text style={styles.label2Page2}>Repair Cost:</Text>
              <View
                style={[
                  styles.valueContainerPage2,
                  { top: "0px", left: "175", position: "absolute" },
                ]}
              >
                <Text style={styles.valuePage2}>
                  {formatMoneyNoDecimals(formData.repairCost) || "$N/A"}
                </Text>
              </View>
            </View>
          </View>
        </View>
      </View>

      {/* Right Column */}
      <View style={styles.rightContainerPage2}>
        <View style={styles.rightColumnPage2}>
          <Text style={styles.sectionHeaderRightsPage2}>
            ASSIGNMENT, COMPLIANCE & SCOPE
          </Text>
          <Text style={styles.paragraphPage2}>
            The purpose of this report is to provide a set of opinions
            {"\n"}and conclusions as to the loss in resale value suffered due
            {"\n"}to the incident reported herein.
            {"\n\n"}
            The analysis, opinions, and conclusions were developed,
            {"\n"}and this report has been prepared, in conformity and
            {"\n"}compliance with the Uniform Standards of Professional
            {"\n"}Appraisal Practice (USPAP).
            {"\n\n"}
            We established this report's findings after examining
            {"\n"}documents provided to us by the insured, the insurer, or their
            {"\n"}agents as well as independent research.
          </Text>
        </View>

        <View style={styles.rightColumnPage2}>
          <Text style={styles.sectionHeaderRightPage2}>
            PATENT PENDING US20200143433A1
          </Text>
          <Text style={styles.paragraphPage2}>
            Submitted to the United States Patent and Trademark office
            {"\n"}- Product Appraisal.
          </Text>
        </View>

        <View style={styles.rightColumnPage2}>
          <Text style={styles.sectionHeaderInventionPage2}>
            TITLE OF INVENTION:
          </Text>
          <Text style={styles.paragraphPage2}>
            A METHOD FOR DIMINISHED VALUE CALCULATION
            {"\n"}IN REPAIRED VEHICLES.
            {"\n\n"}
            Inventor: Tony Rached
            {"\n"}Classification: G06Q30/0278
          </Text>
        </View>

        <View style={styles.rightColumnPage2}>
          <Text style={styles.sectionHeaderInventionPage2}>
            PATENT ABSTRACT OF DISCLOSURE
          </Text>
          <Text style={styles.paragraphPage2}>
            The invention consists of a method for calculating
            {"\n"}diminished value in automobiles and other roadway
            {"\n"}vehicles. Diminished value is the inherent loss in resale
            {"\n"}value a vehicle suffers as a result of a collision, flood
            {"\n"}or other physical damage such that would require body
            {"\n"}work and repairs.
            {"\n\n"}
            {"\n"}
            This value is found by finding a range of potential values
            {"\n"}of analogous vehicles in order to establish the range of the
            {"\n"}loss, then applying a coefficient to that value to determine
            {"\n"}where in the range the damaged and repaired vehicle
            {"\n"}properly falls. The coefficient correlating to the damages is
            {"\n"}found by taking the average of sub coefficients tied to the
            {"\n"}relative cost of repair, the amount of labor needed to fix the
            {"\n"}damage, and the degree of structural damage incurred.
            {"\n\n"}
            {"\n"}
            While it is commonplace on the market for the sale price of
            {"\n"}a refurbished automobile to be decreased as a result of
            {"\n"}repairs, to what degree the value should be decreased is
            {"\n"}unclear and existing methods are often imprecise,
            {"\n"}unsatisfactory and conclusory in nature.
          </Text>
        </View>
      </View>
    </View>

    <View style={styles.TitleBottomBorderTwoPage2} />
    <View style={styles.TitleBottomBorderThreePage2} />
    <View style={styles.TitleBottomBorderFourPage2} />

    <Footer />
  </Page>
);

export default Page2;
